<template>
	<transition name="h-tab">
		<div class="o-tab" v-show="this.currentTab" :class="{'is-active':this.currentTab	}">
			<slot name="content" :active="this.currentTab"></slot>
		</div>
	</div>
</template>

<script>
  export default {
		name: 'v-tab',
    data () {
      return {
      }
    },
		props: {
			name: {
				type: String
			}
		},
    computed: {
      currentTab() {
        return this.$store.state.currentTab === this.name;
      },
    }
	}
</script>



// WEBPACK FOOTER //
// tab.vue?5b5de806